import React, { useState } from "react";
import { Sparkle, Brain, ArrowClockwise, ChartLineUp } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AiPanel({ utenze }) {
  const [meterId, setMeterId] = useState(utenze[0]?.id || "");
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (utenze[0] && !meterId) setMeterId(utenze[0].id);
  }, [utenze, meterId]);

  const analyze = async () => {
    if (!meterId) return;
    setLoading(true);
    setAnalysis(null);
    try {
      const { data } = await api.post("/v1/ai/analyze", { meter_id: meterId });
      setAnalysis(data);
      toast.success("Analisi Claude ML completata");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Analisi AI fallita");
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-[#111827] border border-slate-800 rounded-lg relative ai-pulse" data-testid="ai-panel">
      <div className="px-5 py-4 border-b border-slate-800 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Brain size={20} weight="duotone" className="text-[#3EB6F0]" />
          <div>
            <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Claude ML</div>
            <div className="font-heading text-lg text-white">Analisi Predittiva</div>
          </div>
        </div>
        <span className="text-[10px] font-mono px-2 py-1 rounded bg-[#3EB6F0]/10 text-[#3EB6F0] border border-[#3EB6F0]/30 uppercase tracking-widest">Sonnet 5</span>
      </div>
      <div className="p-5 space-y-4">
        <div className="flex gap-2">
          <Select value={meterId} onValueChange={setMeterId}>
            <SelectTrigger className="flex-1 bg-[#0a0f1c] border-slate-800 font-mono text-sm" data-testid="ai-meter-select">
              <SelectValue placeholder="Seleziona allaccio" />
            </SelectTrigger>
            <SelectContent className="bg-[#111827] border-slate-800">
              {utenze.map((u) => (
                <SelectItem key={u.id} value={u.id} className="font-mono text-xs">
                  {u.id} · {u.indirizzo} {u.allarme === "HIGH" && "· ⚠"}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button onClick={analyze} disabled={loading} data-testid="ai-analyze-button"
            className="bg-[#3EB6F0] hover:bg-[#2CA4DE] text-[#070B14] font-semibold gap-2">
            {loading ? <ArrowClockwise className="animate-spin" /> : <Sparkle weight="fill" />}
            {loading ? "Analisi..." : "Analizza"}
          </Button>
        </div>

        {analysis && (
          <div className="border border-slate-800 rounded-md p-4 bg-[#0a0f1c] space-y-3" data-testid="ai-analysis-result">
            <div className="flex items-center gap-3 text-xs font-mono">
              <ChartLineUp size={14} className="text-[#3EB6F0]" />
              <span className="text-slate-400">Z-Score:</span>
              <span className="text-white">{analysis.z_score}</span>
              <span className="text-slate-400">·</span>
              <span className="text-slate-400">Stato ML:</span>
              <span className="text-[#3EB6F0]">{analysis.ml_status}</span>
              <span className="text-slate-400">·</span>
              <span className="text-slate-500">{analysis.model}</span>
            </div>
            <div className="text-sm text-slate-200 leading-relaxed whitespace-pre-wrap font-sans">
              {analysis.analysis}
            </div>
          </div>
        )}
        {!analysis && !loading && (
          <div className="text-xs text-slate-500 font-mono text-center py-4">
            Seleziona un allaccio e avvia l'analisi predittiva Claude
          </div>
        )}
      </div>
    </div>
  );
}
